<template>
  <div>
    <table v-show="_isOrderHead">
      <tr>
        <td>
          <SogDataLabel :value="_orderHead.orderNumber" />
          <SogButton
            mdi-icon="mdi-information"
            :button-style="SogButtonStyle.Link"
            @click="onOrderHeadClick"
          />
        </td>
      </tr>
      <tr>
        <td>
          <SogDataLabel
            :value="_orderHead.orderedDate"
            :value-type="SogDataLabelValueType.DateTime"
          />
        </td>
      </tr>
    </table>
    <table v-show="_isString">
      <tr>
        <td>
          <SogDataLabel :value="_stringValue.value" />
        </td>
      </tr>
    </table>
    <table v-show="_isIdString">
      <tr>
        <td>
          <SogDataLabel :value="_idString.value" />
          <SogButton
            :mdi-icon="_mdiIdType"
            :button-style="SogButtonStyle.Link"
            @click="onIdStringClick"
          />
        </td>
      </tr>
    </table>
    <table v-show="_isOrderItemToInsurance">
      <tr>
        <td>
          <SogDataLabel :value="_orderItemToInsurance.orderNumber" />
          <SogButton
            mdi-icon="mdi-information"
            :button-style="SogButtonStyle.Link"
            @click="onOrderItemToInsuranceClick"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script setup lang="ts">

import HistoryDetails from "@/shared/model/HistoryDetails";
import {computed} from "vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import {HistoryDetailsType} from "@/shared/model/HistoryDetailsType";
import HistoryDetailsString from "@/shared/model/HistoryDetailsString";
import HistoryDetailsOrderHeadInfo from "@/shared/model/HistoryDetailsOrderHeadInfo";
import HistoryDetailsOrderItemToInsuranceInfo from "@/shared/model/HistoryDetailsOrderItemToInsuranceInfo";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import SogButton from "@/shared/ui/SogButton.vue";
import {IdType} from "@/shared/model/idType";
import {useNavigationStore} from "@/modules/Navigation/store";
import HistoryDetailsIdString from "@/shared/model/HistoryDetailsIdString";

interface Props {
  details?: HistoryDetails
}

const props = withDefaults(defineProps<Props>(), {
    details: undefined
  }
)

const _navigationStore = useNavigationStore()


const _isOrderHead = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.OrderHeadInfo
  }
  return false
})

const _isString = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.String
  }
  return false
})

const _isIdString = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.IdString
  }
  return false
})


const _isOrderItemToInsurance = computed(() => {
  if (props.details) {
    return props.details.getType() === HistoryDetailsType.OrderItemToInsuranceInfo
  }
  return false
})

const _orderHead = computed<HistoryDetailsOrderHeadInfo>(() => {
  if (_isOrderHead.value)
    return props.details as HistoryDetailsOrderHeadInfo;
  return new HistoryDetailsOrderHeadInfo()
})

const _orderItemToInsurance = computed<HistoryDetailsOrderItemToInsuranceInfo>(() => {
  if (_isOrderItemToInsurance.value)
    return props.details as HistoryDetailsOrderItemToInsuranceInfo;
  return new HistoryDetailsOrderHeadInfo()
})


const _stringValue = computed(() => {
  if (_isString.value)
    return props.details as HistoryDetailsString;
  return new HistoryDetailsString()
})

const _idString = computed(() => {
  if (_isIdString.value)
    return props.details as HistoryDetailsIdString;
  return new HistoryDetailsIdString()
})

const _idType = computed(() => {
  if (_isIdString.value)
    ////  const t = (<any>IdType)[_idString.value.idType];

    return IdType[_idString.value.idType];
  return undefined
})

const _mdiIdType = computed(() => {
  switch (_idType.value) {
    case IdType.Insurance:
      return "mdi-shield";
    case IdType.VehicleRegistration:
      return "mdi-car";
    case IdType.InsuranceExportBlank:
      return "mdi-file-document";
  }
  return "mdi-information";
})

async function onOrderItemToInsuranceClick() {
  await _navigationStore.showObject(IdType.Order, _orderItemToInsurance.value.orderId ?? "");
}

async function onOrderHeadClick() {
  await _navigationStore.showObject(IdType.Order, _orderHead.value.id ?? "");
}

async function onIdStringClick() {
  await _navigationStore.showObject(_idType.value, _idString.value.id ?? "");
}


</script>

<style scoped>

</style>
